import api from '../../services/service'

export default {
  data () {
    return {
      username: '',
      password: '',
      check_con: '',
      secon_timer: 0,
      header: {
        headers: {
          'Access-Token': ''
        }
      }
    }
  },
  methods: {
    sigin () {
      this.$store.commit('Loading')
      let body = {
        'username': this.username,
        'password': this.password
      }
      api.isLogin(this.REST_URL,
        body,
        result => {
          if (result.response === 'success') {
            sessionStorage.token = result.data.token
            this.$store.state.token = result.data.token
            this.getProfile()
          } else {
            this.$notification['warning']({
              message: 'เข้าสู่ระบบ',
              description:
                result.message
            })
            this.$store.commit('Loading')
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    getProfile () {
      api.userDetail(this.REST_URL,
        {
          headers: {
            'Access-Token': sessionStorage.token
          }
        },
        {},
        result => {
          if (result.response === 'success') {
            sessionStorage.user = JSON.stringify(result.data)
            this.$store.state.user = result.data
            localStorage.setItem('user', sessionStorage.user)
            this.$notification['success']({
              message: 'เข้าสู่ระบบ',
              description:
                'ยินดีตอนรับคุณ ' + this.username + ' เข้าสู่ระบบ'
            })
            this.autoGoToPOS()
          } else {
            this.$notification['warning']({
              message: 'เข้าสู่ระบบ',
              description:
                result.message
            })
          }
          this.$store.commit('Loading')
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
          this.$store.commit('Loading')
        }
      )
    },
    autoGoToPOS () {
      this.header.headers['Access-Token'] = sessionStorage.token
      api.getHostShift(
        this.REST_URL,
        { headers: { 'Access-Token': sessionStorage.token } },
        result => {
          if (result.response === 'success' && result.data && result.data.length > 0) {
            this.getListHostDetail(result.data[0])
          } else {
            this.$router.push('/')
          }
        },
        _error => {
          this.$router.push('/')
        }
      )
    },
    checkConnect () {
      this.$store.state.isLoading = true
      api.userDetail(this.REST_URL,
        {
          headers: {
            'Access-Token': sessionStorage.token
          }
        },
        {},
        result => {
          if (result.response) {
            this.$store.state.isLoading = false
            clearInterval(this.check_con)
            console.log('use time' + this.secon_timer)
          }
        },
        // eslint-disable-next-line handle-callback-err
        error => {
          console.log(error.message)
          if (error.message === 'Request failed with status code 404' || error.message === 'Network Error') {
            console.log('connect error')
            setTimeout(() => {
              this.checkConnect()
            }, 3000)
          } else {
            this.$store.state.isLoading = false
            clearInterval(this.check_con)
            console.log('use time' + this.secon_timer)
          }
        }
      )
    }
  },
  mounted () {
    this.$store.commit('clearState')
    this.checkConnect()
    // this.check_con = setInterval(() => {
    //   this.checkConnect()
    //   this.secon_timer += 3
    // }, 3000)
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/login.js